<template>
  <LegalPage
    title="Privacy Policy"
    subtitle="Last updated: August 2026"
    intro="This page explains how gbwhatsdroid.com handles information when you visit the site or contact us by email."
    :sections="sections"
    email="contact@gbwhatsdroid.com"
    page-name="privacy"
  />
</template>

<script>
import LegalPage from '@/components/LegalPage.vue';

export default {
  name: 'Privacy',
  components: {
    LegalPage,
  },
  data() {
    return {
      sections: [
        {
          heading: 'Scope of This Policy',
          paragraphs: [
            'This policy applies to the information and guidance published on gbwhatsdroid.com. We do not operate WhatsApp, GBWhatsApp, or the APK download service referenced on this site.',
            'The site is an independent information resource. It does not create an official relationship with WhatsApp Inc., Meta, or any GBWhatsApp developer.',
          ],
        },
        {
          heading: 'Information We Collect',
          paragraphs: [
            'When you browse this site, standard technical information may be processed automatically, including browser type, device category, approximate location based on server logs, pages visited, and the referring page.',
            'If you contact us through email, we receive the email address and any information you choose to include in your message. We use that information only to respond to the inquiry.',
          ],
        },
        {
          heading: 'How We Use Information',
          paragraphs: [
            'We use the limited information described above to keep the site available, understand how visitors use the content, improve page quality, and answer support requests.',
          ],
          items: [
            'Maintain site performance and security.',
            'Review popular pages and fix outdated guidance.',
            'Respond to questions about downloads or site content.',
            'Prevent misuse of the contact address.',
          ],
        },
        {
          heading: 'Cookies and Analytics',
          paragraphs: [
            'This site may use basic cookies or similar technologies for preferences and visitor measurement. You can disable cookies through your browser settings without losing access to the written content.',
          ],
        },
        {
          heading: 'Third-Party Links',
          paragraphs: [
            'Pages may link to third-party websites, APK files, or download providers. We do not control those services and cannot guarantee their privacy practices, security, or availability.',
            'Before downloading or installing any file, review the third-party page, check the file source, and consider whether the download is right for your device.',
          ],
        },
        {
          heading: 'Data Security',
          paragraphs: [
            'We take reasonable administrative and technical measures to protect the site. However, no website or email system can provide absolute security.',
          ],
        },
        {
          heading: 'Children',
          paragraphs: [
            'This site is intended for users who can lawfully use Android messaging applications. We do not knowingly collect personal information from children.',
          ],
        },
        {
          heading: 'Changes',
          paragraphs: [
            'This policy may be updated when the site content or applicable practices change. The updated version will be posted on this page.',
          ],
        },
      ],
    };
  },
};
</script>
